import { GatsbyBrowser } from 'gatsby';
import { setupCookieSync, initialLandingPage } from '@lucid/utils';

const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location, prevLocation }) => {
  const maxAttempts = 3;
  let attempt = 0;
  const recordPage = () => {
    try {
      if (window.lucid && window.lucid.beacon) {
        window.lucid.beacon.recordPageChange(location.href);
      }
    } catch (e) {
      if (attempt < maxAttempts) {
        attempt += 1;
        setTimeout(() => recordPage(), 100);
      } else {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    }
  };

  if (typeof window !== 'undefined') {
    if (prevLocation && window.lucid && window.lucid.beacon && window.lucid.beacon.recordPageChange) {
      setTimeout(() => recordPage(), 200);
    }
  }
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const onInitialClientRender: GatsbyBrowser['onInitialClientRender'] = () => {
  const iframeLocation = (window && window.location) || null;

  setupCookieSync(iframeLocation);
  initialLandingPage();
};

export { onRouteUpdate, onInitialClientRender };
